export default "/assets/images/award-img-01.png?d4dd0b65b23f02c388ccf5f9352503ea";